/**
 * 下游客户热力图（/downstream-heat）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C(scope, key, default) 读取。
 * 热力网络数据来自 src/data/caseinHeat（与 src/data/companyNetwork 关联），外置为数组字段可直接维护。
 */
import { caseinHeat } from '@/data/caseinHeat'

export default {
  title: '下游客户热力图',
  groups: [
    {
      title: '页头区域',
      fields: [
        { key: 'pageTitle', label: '页面主标题', type: 'text', default: '下游客户热力图' },
        { key: 'backText', label: '返回按钮文字', type: 'text', default: '返回经营数据' },
        { key: 'chipKeyword', label: '关键词标签', type: 'text', default: '关键词：酪蛋白' },
        { key: 'chipCountSuf', label: '企业数量后缀', type: 'text', default: '家下游/关联企业' },
        { key: 'chipHeat', label: '热力口径说明标签', type: 'text', default: '热力 = 「酪蛋白」公开信息正向使用频次 × 应用强度' },
      ],
    },
    {
      title: '热力榜与提示',
      fields: [
        { key: 'boardHead', label: '榜单标题', type: 'text', default: '酪蛋白热力 TOP 10' },
        { key: 'chartTip', label: '网络图说明文字', type: 'text', default: '节点大小与颜色 = 热力值 · 节点持续缓慢游走中 · 点击企业节点查看详情' },
      ],
    },
    {
      title: '页脚',
      fields: [
        { key: 'footerLogo', label: '页脚品牌名', type: 'text', default: '康巴圣德' },
        { key: 'footerText', label: '页脚数据来源说明', type: 'textarea', default: '数据来源：企业公开工商 / 专利 / 官网 / 年报 / 环评 / 行业公开资讯中「酪蛋白」字样正向使用频次推演，仅供市场调研与数字看板展示' },
      ],
    },
    {
      title: '枢纽节点（中心）',
      fields: [
        { key: 'hubName', label: '枢纽企业名称', type: 'text', default: '康巴圣德' },
        { key: 'hubNote', label: '枢纽节点副标题', type: 'text', default: '酪蛋白酸钠生产商 · 热力枢纽' },
        { key: 'hubTooltip', label: '枢纽悬浮提示', type: 'text', default: '康巴圣德（酪蛋白酸钠生产商）· 热力枢纽' },
      ],
    },
    {
      title: '数据指标（直接编辑当前值）',
      fields: [
        { key: 'caseinHeat', label: '下游企业热力数据', type: 'array', default: caseinHeat },
      ],
    },
    {
      title: '图片与视频',
      fields: [
        { key: 'pageBg', label: '页面背景图（覆盖默认渐变）', type: 'image', default: '' },
      ],
    },
  ],
}
